import { render, staticRenderFns } from "./RecommendProducts.vue?vue&type=template&id=3e8afa1c"
import script from "./RecommendProducts.vue?vue&type=script&lang=js"
export * from "./RecommendProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports